import React from "react";
import Truncate from "react-truncated-component";
import PropTypes from "prop-types";

import { UncontrolledAssigner as Assigner } from "scenes/Hubly/components/Workspace/components/Assigner";

export function SimpleTaskView({ title, currentAssignee, showAssignAdvisor }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "5px",
        padding: "0.5em 0.5em 0",
      }}
    >
      <div style={{ display: "flex", flexFlow: "row" }}>
        <div style={{ width: "41px" }} />
        {showAssignAdvisor && (
          <div style={{ width: "25px", padding: "0", marginTop: "3px" }}>
            <Assigner
              size="small"
              currentAssignee={currentAssignee}
              onAssign={() => {}}
            />
          </div>
        )}
        <div
          style={{
            flexGrow: 1,
            margin: `0.2em ${showAssignAdvisor ? 0.5 : 0.25}em 0`,
            color: "#AAAAAA",
          }}
        >
          <Truncate ellipsis="..." numberOfLines={1} lineHeight={22}>
            <p>{title}</p>
          </Truncate>
        </div>
      </div>
    </div>
  );
}

SimpleTaskView.propTypes = {
  showAssignAdvisor: PropTypes.bool,
  title: PropTypes.string,
  currentAssignee: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

SimpleTaskView.defaultProps = {
  showAssignAdvisor: false,
  title: "",
  currentAssignee: null,
};

export default SimpleTaskView;
